import { useTranslation } from 'react-i18next'
import { buildMeta } from '#app/utils/seo.ts'
import { type Route } from './+types/privacy.ts'

export const handle = { i18n: 'common' }

export const meta: Route.MetaFunction = () => {
	return buildMeta({
		title: 'Privacybeleid',
		description:
			'Privacybeleid van elseringnalda.nl. Lees hoe wij omgaan met uw persoonsgegevens.',
		url: '/privacy',
		noIndex: false,
	})
}

export default function PrivacyRoute() {
	const { t } = useTranslation()
	return (
		<div className="container mx-auto max-w-2xl px-6 py-24">
			<h1 className="display mb-6" style={{ fontSize: 36 }}>
				{t('privacyHeading')}
			</h1>
			<p style={{ color: 'var(--ink-soft)' }}>{t('contentComingSoon')}</p>
		</div>
	)
}
